var _desc, _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNearWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(Infinity NaN NaN Infinity 0 0)",
    id: "6b5b359d-e6e6-4927-816a-a41c74d12369"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 50 50)",
    id: "181fa84f-9073-46ab-862e-47588f0b4284"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -50,
    y: -50,
    rx: 0,
    ry: 0,
    width: 100,
    height: 100
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.09 0 0 0.09 170.41 169.07)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-45.05, -45)",
    d: "M 72.2 4.6 L 53.4 32.5 C 52.1 34.4 54.6 36.7 56.4 35.1 L 74.9 19 C 75.4 18.6 76.10000000000001 18.9 76.10000000000001 19.6 L 76.10000000000001 69.9 C 76.10000000000001 70.60000000000001 75.2 70.9 74.80000000000001 70.4 L 18.80000000000001 3.4000000000000057 C 17 1.2 14.4 0 11.5 0 L 9.5 0 C 4.3 0 0 4.3 0 9.6 L 0 80.39999999999999 C 0 85.7 4.3 90 9.6 90 C 12.899999999999999 90 16 88.3 17.799999999999997 85.4 L 36.599999999999994 57.50000000000001 C 37.89999999999999 55.60000000000001 35.39999999999999 53.300000000000004 33.599999999999994 54.900000000000006 L 15.099999999999994 70.9 C 14.599999999999994 71.30000000000001 13.899999999999995 71 13.899999999999995 70.30000000000001 L 13.899999999999995 20.1 C 13.899999999999995 19.400000000000002 14.799999999999995 19.1 15.199999999999996 19.6 L 71.19999999999999 86.6 C 72.99999999999999 88.8 75.69999999999999 90 78.49999999999999 90 L 80.49999999999999 90 C 85.79999999999998 90 90.09999999999998 85.7 90.09999999999998 80.4 L 90.09999999999998 9.6 C 90.09999999999998 4.3 85.79999999999998 0 80.49999999999999 0 C 77.1 0 74 1.7 72.2 4.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 50 50)",
    id: "fa5f6faf-ea70-413e-8dda-4c7d786705af"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-45.05, -45)",
    d: "M 72.2 4.6 L 53.4 32.5 C 52.1 34.4 54.6 36.7 56.4 35.1 L 74.9 19 C 75.4 18.6 76.10000000000001 18.9 76.10000000000001 19.6 L 76.10000000000001 69.9 C 76.10000000000001 70.60000000000001 75.2 70.9 74.80000000000001 70.4 L 18.80000000000001 3.4000000000000057 C 17 1.2 14.4 0 11.5 0 L 9.5 0 C 4.3 0 0 4.3 0 9.6 L 0 80.39999999999999 C 0 85.7 4.3 90 9.6 90 C 12.899999999999999 90 16 88.3 17.799999999999997 85.4 L 36.599999999999994 57.50000000000001 C 37.89999999999999 55.60000000000001 35.39999999999999 53.300000000000004 33.599999999999994 54.900000000000006 L 15.099999999999994 70.9 C 14.599999999999994 71.30000000000001 13.899999999999995 71 13.899999999999995 70.30000000000001 L 13.899999999999995 20.1 C 13.899999999999995 19.400000000000002 14.799999999999995 19.1 15.199999999999996 19.6 L 71.19999999999999 86.6 C 72.99999999999999 88.8 75.69999999999999 90 78.49999999999999 90 L 80.49999999999999 90 C 85.79999999999998 90 90.09999999999998 85.7 90.09999999999998 80.4 L 90.09999999999998 9.6 C 90.09999999999998 4.3 85.79999999999998 0 80.49999999999999 0 C 77.1 0 74 1.7 72.2 4.6 z",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNearWallet);
export default __webpack_public_path__ + "static/media/nearWallet.33c4035a53f46b4dea8dd9efe8000340.svg";
export { ForwardRef as ReactComponent };